import {
    ReactElement,
} from 'react';

import {Stack,} from '@mantine/core';

import {usePlaybooks} from '../hooks/usePlaybooks.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {usePlaybooksSelection} from '../hooks/usePlaybooksSelection.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {usePlaybooksPaging} from "../hooks/usePlaybooksPaging.ts";
import {usePlaybooksSearch} from "../hooks/usePlaybooksSearch.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()


    const {
        columns,
        visibleItems: records,
        loading,
    } = usePlaybooks();

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = usePlaybooksPaging();

    const {
        handleFilterByKeyword,
    } = usePlaybooksSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = usePlaybooksSelection();


    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeletePlaybook)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => ({ id }))
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as any).id, true)
                    })
                }}
                fetching={loading}
            />


        </Stack>
    );


};
